import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-10 md:py-16 bg-gradient-to-b from-[#D8F3DC] to-[#95D5B2]" data-id="element-142">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-144">
          <div className="inline-flex items-center gap-2 bg-white px-3 py-1.5 rounded-full mb-4 shadow-md" data-id="element-145">
            <SparklesIcon className="w-4 h-4 text-[#2D6A4F]" data-id="element-146" />
            <span className="font-medium text-sm text-[#2D6A4F]" data-id="element-147">
              El Mecanismo Único
            </span>
          </div>

          <h2 className="font-heading text-2xl md:text-4xl font-bold text-[#2D6A4F] mb-4" data-id="element-148">
            El Sistema de las 3 Macetas
          </h2>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-149">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed" data-id="element-150">
              Es un método de ingeniería urbana diseñado para la vida moderna.
              Clasificamos tu balcón en 3 zonas de luz real y asignamos solo
              'especies velocistas' (plantas que crecen en 30 días o menos).
              Olvida esperar meses para ver un brote; aquí trabajamos con
              rábano, rúcula y lechuga 'baby' para que cenes lo que siembras
              antes de que termine el mes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}